import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '@/lib/db';

const AuthContext = createContext({});

const TOKEN_KEY = 'reviewfilter_token';
const USER_KEY = 'reviewfilter_user';
const SA_BACKUP_KEY = 'reviewfilter_sa_backup';
const SA_TOKEN_BACKUP_KEY = 'reviewfilter_sa_backup_token';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem(USER_KEY);
    if (storedUser) setUser(JSON.parse(storedUser));
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const userData = await api.login(email, password);
    const { token, ...userWithoutToken } = userData;

    // Token mentése
    if (token) localStorage.setItem(TOKEN_KEY, token);

    // Felhasználó adatok mentése (token nélkül)
    setUser(userWithoutToken);
    localStorage.setItem(USER_KEY, JSON.stringify(userWithoutToken));

    // Tiszta bejelentkezésnél töröljük a backupot
    localStorage.removeItem(SA_BACKUP_KEY);
    localStorage.removeItem(SA_TOKEN_BACKUP_KEY);

    return userWithoutToken;
  };

  const impersonate = async (businessId) => {
    // Mentsük el az aktuális superadmin tokent és felhasználó adatait
    const currentToken = localStorage.getItem(TOKEN_KEY);
    const currentUser = localStorage.getItem(USER_KEY);

    if (currentUser) {
      const parsed = JSON.parse(currentUser);
      if (parsed.role === 'superadmin') {
        localStorage.setItem(SA_BACKUP_KEY, currentUser);
        if (currentToken) localStorage.setItem(SA_TOKEN_BACKUP_KEY, currentToken);
      }
    }

    // Impersonation token lekérése
    const userData = await api.impersonateAs(businessId);
    const { token, ...userWithoutToken } = userData;

    if (token) localStorage.setItem(TOKEN_KEY, token);
    setUser(userWithoutToken);
    localStorage.setItem(USER_KEY, JSON.stringify(userWithoutToken));

    return userWithoutToken;
  };

  const returnToSuperAdmin = () => {
    const backup = localStorage.getItem(SA_BACKUP_KEY);
    const backupToken = localStorage.getItem(SA_TOKEN_BACKUP_KEY);
    if (!backup) return false;

    const sa = JSON.parse(backup);
    setUser(sa);
    localStorage.setItem(USER_KEY, backup);
    if (backupToken) localStorage.setItem(TOKEN_KEY, backupToken);

    localStorage.removeItem(SA_BACKUP_KEY);
    localStorage.removeItem(SA_TOKEN_BACKUP_KEY);
    return true;
  };

  const hasSuperAdminBackup = () => {
    return !!localStorage.getItem(SA_BACKUP_KEY);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(SA_BACKUP_KEY);
    localStorage.removeItem(SA_TOKEN_BACKUP_KEY);
  };

  return (
    <AuthContext.Provider value={{ user, login, impersonate, returnToSuperAdmin, hasSuperAdminBackup, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
